<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="CollegePrintForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">

                <div class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Search College
                            </b></h3>
                        <!-- <p class="text-muted card-sub-title mb-0">
                            
                          </p> -->
                    </div>
                </div>
                <hr>
                <div class="row mt-3 clearfix">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label> District </mat-label>
                                    <mat-select formControlName="DsCode" onkeydown="return (event.keyCode!=13);"
                                        #select333 placeholder="District" class="colorblack">
                                        <mat-select-filter *ngIf="select333.focused" [placeholder]="'Filter'"
                                            [displayMember]="'DsName'" [array]="DsCodelist"
                                            (filteredReturn)="filteredListDistCode =$event">
                                        </mat-select-filter>
                                        <mat-option *ngFor="let item of filteredListDistCode" [value]="item.DsCode"
                                            (click)="SelectTn(item.DsCode)"> {{item.DsName}} </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label> Town </mat-label>
                                    <mat-select onkeydown="return (event.keyCode!=13);" #select330 required
                                        placeholder="Town" class="colorblack" [disabled]="districtSelect"
                                        formControlName="TnCode">
                                        <mat-select-filter *ngIf="select330.focused" [placeholder]="'Filter'"
                                            [displayMember]="'TnName'" [array]="tncodelist"
                                            (filteredReturn)="filteredListTownCode =$event">
                                        </mat-select-filter>
                                        <mat-option *ngFor="let item of filteredListTownCode" [value]="item.TnCode">
                                            {{item.TnName}} </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>Type</mat-label>
                                <mat-select formControlName="CgType" #select104 class="colorblack">
                                    <mat-option value="0"></mat-option>
                                    <mat-option value="1"></mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label> {{'header.college-data.titleList.CollegeCode' |
                                        translate }} </mat-label> <input onkeydown="return (event.keyCode!=13);"
                                        class="color" maxlength="5" type="text" placeholder="College Code"
                                        formControlName="CgCode" matInput>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label> Name Like </mat-label> <input onkeydown="return (event.keyCode!=13);"
                                        class="color" maxlength="5" type="text" placeholder="Name Like"
                                        formControlName="CgName" matInput>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 pr-0">
                        <div class="form-group">
                            <mat-card-content class="line-height3">
                                <mat-checkbox onkeydown="return (event.keyCode!=13);" class="example-margin mt-2"
                                    formControlName="CgCent">
                                    Center</mat-checkbox>
                            </mat-card-content>

                            <mat-card-content class="line-height3" style="float:right;">
                                <mat-checkbox onkeydown="return (event.keyCode!=13);" class="example-margin"
                                    formControlName="CgOnlyCent">Only
                                    Center</mat-checkbox>
                            </mat-card-content>

                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>WithAddr</mat-label>
                                <mat-select formControlName="WithAddr" #select104 class="colorblack">
                                    <mat-option value="Y">Y</mat-option>
                                    <mat-option value="N">N</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row col-sm-12">
                        <div class="col-sm-12 prpl">
                            <!-- <button type="button" *ngIf="deleteButton && ColgDelete"
                                class="btn btn-primary btn-icon-text floatright mt-1"
                                (click)="openConformationModalBox()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                    Delete
                                </span>
                            </button> -->
                            
                            <!-- <button type="button" [mat-dialog-close]="true"
                                class="btn size btn-primary btn-icon-text floatright mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                    Back
                                </span>
                            </button> -->
                            <button type="button" class="btn sz btn-primary btn-icon-text floatright mr-3 mt-1"
                                (click)="Print()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
                                    Print
                                </span>
                            </button>
                            <button type="button"  [mat-dialog-close]="true" class="btn btn-primary btn-icon-text floatright mr-3 mt-1"
                                (click)="List()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                    Back
                                </span>
                            </button>
                        </div>
                    </div>
                    <hr class="mt-3">
                    <div class="col-sm-12 pl-0">
                        <div *ngIf="Table">
                            <div class="table-responsive table-container" id="table">
                                <table class="table table-bordered text-nowrap">
                                    <thead>
                                        <tr class="text-left">
                                            <th class="f600">
                                                Code
                                            </th>
                                            <th class="f600">
                                                Short Name
                                            </th>
                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                District
                                            </th>
                                            <th class="f600">
                                                District Name
                                            </th>
                                            <th class="f600">
                                                Town
                                            </th>
                                            <th class="f600">
                                                Town Name
                                            </th>
                                            <th class="f600">
                                                Cent
                                            </th>
                                            <th class="f600">
                                                OnlyCent
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="curs">
                                        <!-- (click)="editdata(item)"  *ngFor="let item of GridData;" (click)="scrollToId('action')" [class.selected-row]="item === selectedRow" (click)="selected(item)"-->
                                        <tr  *ngFor="let item of GridData;">
                                            <td>{{item.CgCode}}</td>
                                            <td>{{item.CgShName}}</td>
                                            <td>{{item.CgName}}</td>
                                            <td>{{item.DsCode}}</td>
                                            <td>{{item.DsName}}</td>
                                            <td>{{item.TnCode}}</td>
                                            <td>{{item.TnName}}</td>
                                            <td>{{item.CgCode}}</td>
                                            <td>{{item.CgS1Cent}}</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>